import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import axios from "axios"; // Import axios for making HTTP requests
import { useForm } from "react-hook-form";
import {
  userLogin,
  userForgotPassword,
  userRegistration,
  createCustomer,
  userGuestLogin,
  guestOtpVerification
} from "../../services/UserLogin.service";
import { sendSubscriptionEmail } from "../../utils/emailService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { PATH, RESTAURANT_ID } from "../../redux/constants/Constants";
import {
  getUserTokenAction,
  userCartDetails,
  userCartItems,
  rememberMe,
  forgetMe,
  clearPreLoginCart,
} from "../../redux/actions/Actions";
import {
  addToCart,
  cartAvailability,
  createCart,
  getCartItems,
} from "../../services/Cart.service";

export default function Login({ show, onHide, customMessage }) {
  const [countryCode, setCountryCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState(null);
  const userData = useSelector((state) => state?.user?.user?.token);
  const cartId = useSelector(
    (state) => state?.cart?.cart?.results && state?.cart?.cart?.results[0]?.id
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state?.status?.restaurant?.Token);
  let intlTelInputRef = useRef(null);
  const currencySymbol = useSelector(
    (state) => state?.status?.restaurant?.currency_symbol
  );

  const { rememberedEmail, rememberedPassword } = useSelector(
    (state) => state?.rememberMe
  );

  const [isRememberedMe, setIsRememberedMe] = useState(
    rememberedEmail ? true : false
  );

  // console.log(rememberedEmail, rememberedPassword);

  const preLoginCount = useSelector(
    (state) => state?.preLoginCart?.preLoginCart?.length
  );
  // console.log(preLoginCount);
  const preLoginCart = useSelector(
    (state) => state?.preLoginCart?.preLoginCart
  );
  // console.log(preLoginCart);

  const [view, setView] = useState("login"); // "login", "forgot_password", "reset_success"
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [resendEmailStatus, setResendEmailStatus] = useState("idle");

  const [showGuestLoginModal, setShowGuestLoginModal] = useState(false);
  const [showOTPVerificationModal, setShowOTPVerificationModal] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    reset,
    handleSubmit: handleSubmitSignIn,
    setValue,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (rememberedEmail && rememberedPassword) {
      setValue("email", rememberedEmail);
      setValue("password", rememberedPassword);
      setIsRememberedMe(true);
    }
  }, [rememberedEmail, rememberedPassword, setValue]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (location.state?.showGuestLoginModal) {
      setView("guest_login");
      // Clean up the state so it doesn't reopen on refresh
      window.history.replaceState({}, document.title);
    }

    cartId &&
      getCartItems(token, cartId).then((res) => {
        res && dispatch(userCartItems(res?.data));

        // console.log(res?.data);
      });
    fetchAPIs();
  }, [location]);

  const fetchAPIs = () => {
    cartId &&
      getCartItems(token, cartId).then((res) => {
        dispatch(userCartItems(res?.data));

        // console.log(res?.data);
      });
    // Get user's location using Geolocation API
    // navigator.geolocation.getCurrentPosition(
    //   (position) => {
    //     const { latitude, longitude } = position.coords;
    //     // Make a request to a reverse geocoding service to get the country code
    //     axios
    //       .get(
    //         `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
    //       )
    //       .then((response) => {
    //         // Extract the country code from the response
    //         const countryCode = response.data.countryCode.toUpperCase(); // Ensure uppercase
    //         setCountryCode(countryCode);
    //       })
    //       .catch((error) => {
    //         console.error("Error fetching country code:", error);
    //       });
    //   },
    //   (error) => {
    //     console.error("Error getting user location:", error);
    //   }
    // );
  };

  // console.log(countryCode);

  const {
    register: register2,
    handleSubmit: handleSubmitForgotUsername,
    formState: { errors: errors2 },
  } = useForm({ mode: "onChange" });

  const {
    register: register3,
    handleSubmit: handleSubmitForgotPassword,
    reset: reset3,
    formState: { errors: errors3 },
  } = useForm({ mode: "onChange" });

  const {
    register: register4,
    handleSubmit: handleSubmitGuestLogin,
    reset: reset4,
    setValue: setValue4,
    clearErrors: clearErrors4,
    formState: { errors: errors4 },
  } = useForm({ mode: "onChange" });

  const {
    register: register5,
    handleSubmit: handleSubmitOTPVerification,
    reset: reset5,
    formState: { errors: errors5 },
  } = useForm({ mode: "onChange" });


  const signIn = (item) => {
    if (item.rememberMe) {
      dispatch(rememberMe(item.email, item.password));
    } else {
      dispatch(forgetMe());
    }

    // Call your login service here
    // console.log(data);

    // console.log(item);

    const extractNameFromEmail = (email) => {
      if (!email) return { firstName: "User", lastName: "" };
      const username = email.split('@')[0];
      const parts = username.split(/[._-]/);
      const cleanParts = parts.map(p => p.replace(/[0-9]/g, '')).filter(p => p.length > 0);
      const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
      if (cleanParts.length === 0) return { firstName: "User", lastName: "" };
      const firstName = capitalize(cleanParts[0]);
      const lastName = cleanParts.length > 1 ? capitalize(cleanParts.slice(1).join(" ")) : "";
      return { firstName, lastName };
    };

    const { firstName, lastName } = extractNameFromEmail(item.email);

    // Normalize email to lowercase for case-insensitive matching
    const normalizedEmail = item.email.trim().toLowerCase();

    const data = {
      username: normalizedEmail,
      password: item.password,
      restaurant_id: RESTAURANT_ID,
    };

    JSON.stringify(data);

    // console.log(data);
    setLoading(true);
    setErrorMsg("");

    userLogin(token, data).then((res) => {
      // console.log(res);

      if (res.status === 200) {
        // console.log(res?.data);
        const userData = res?.data;

        localStorage.setItem("isGuest", "false");
        dispatch(getUserTokenAction(res?.data));


        if (userData) {
          cartAvailability(token, userData.id).then((res) => {
            // console.log(res?.data);
            // console.log(res?.data.results?.length < 1);
            if (res?.data.results?.length < 1) {
              const data = {
                customer_id: userData.id,
                restaurant: RESTAURANT_ID,
              };

              createCart(token, data).then((res) => {
                // console.log(res?.data);

                cartAvailability(token, userData.id).then((res) => {
                  // console.log(res?.data);
                  dispatch(userCartDetails(res?.data));

                  if (preLoginCount > 0) {
                    const addToCartPromises = preLoginCart?.map((item) => {
                      let data = {
                        price: item.price,
                        quantity: item.quantity,
                        cart_id: res?.data?.results?.[0]?.id,
                        product_id: item.product_id,
                        color_id: item.color_id,
                      };

                      return addToCart(token, data).then(async (res) => {
                        return res?.data;
                      });
                    });

                    Promise.all(addToCartPromises)
                      .then((results) => {
                        dispatch(clearPreLoginCart());
                        // Fetch cart items after all additions are complete
                        getCartItems(token, res?.data.results[0].id).then((fetchRes) => {
                          dispatch(userCartItems(fetchRes?.data));
                        });
                      })
                      .catch((error) => {
                        console.error("Error adding to cart:", error);
                      });
                  } else {
                    getCartItems(token, res?.data.results[0].id).then((fetchRes) => {
                      dispatch(userCartItems(fetchRes?.data));
                    });
                  }
                }).catch((err) => console.warn(err));
              }).catch((err) => console.warn(err));
            } else {
              cartAvailability(token, userData.id).then((res) => {
                // console.log(res?.data);
                dispatch(userCartDetails(res?.data));

                if (preLoginCount > 0) {
                  const addToCartPromises = preLoginCart?.map((item) => {
                    let data = {
                      price: item.price,
                      quantity: item.quantity,
                      cart_id: res?.data?.results?.[0]?.id,
                      product_id: item.product_id,
                      color_id: item.color_id,
                    };

                    return addToCart(token, data).then(async (res) => {
                      return res?.data;
                    });
                  });

                  Promise.all(addToCartPromises)
                    .then((results) => {
                      dispatch(clearPreLoginCart());
                      // Fetch cart items after all additions are complete
                      getCartItems(token, res?.data.results[0].id).then((fetchRes) => {
                        dispatch(userCartItems(fetchRes?.data));
                      });
                    })
                    .catch((error) => {
                      console.error("Error adding to cart:", error);
                    });
                } else {
                  getCartItems(token, res?.data.results[0].id).then((fetchRes) => {
                    dispatch(userCartItems(fetchRes?.data));
                  });
                }
              }).catch((err) => console.warn(err));

              // console.log(res?.data);
              dispatch(userCartDetails(res?.data));
            }
          }).catch((err) => {
             console.warn("Cart availability error during login:", err?.message);
          });
        }
        // else {
        //   toast.warning("Please Login First...!", {
        //     autoClose: 1500,
        //     style: {
        //       backgroundColor: "black",
        //       color: "white",
        //     },
        //   });

        //   setTimeout(() => {
        //     navigate("/login");
        //   }, 3000);
        // }

        reset();

        if (onHide) onHide();
        if (preLoginCount > 0) {
          navigate("/checkout");
        } else {
          navigate("/");
        }
        setLoading(false);
      } else if (res && res.status >= 400) {
        // Login failed with a server response
        setLoading(false);
        console.log("Login failed response:", res.status, res.data);
        const errData = res?.data || {};
        const allErrorText = (typeof errData === 'string' ? errData : JSON.stringify(errData)).toLowerCase();

        if (allErrorText.includes('not verified') || allErrorText.includes('not_verified') || allErrorText.includes('verify your email')) {
          setLoading(false);
          setErrorMsg('Your account is not verified yet. Please check your emails and verify your email to login.');
        } else {
          throw new Error("Invalid credentials");
        }
      } else if (!res) {
        // Login returned undefined — attempt registration for new user
        throw new Error("User not found, try registration");
      } else {
        throw new Error("Invalid credentials");
      }
    })
    .catch((loginErr) => {
      // If login truly failed (user doesn't exist), try to Register
      // But if the error was already handled, don't try registration
      if (loginErr?.message?.includes('Incorrect password') || loginErr?.message?.includes('not verified')) {
        return; // Already handled above
      }

      const regData = {
        salutation: null,
        first_name: firstName,
        last_name: lastName,
        password: item.password,
        restaurant_id: RESTAURANT_ID,
        verified: "N",
        username: normalizedEmail,
        email: normalizedEmail,
        phone_number: "",
      };

      userRegistration(token, regData)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            // Registration Success
            const customerData = {
              last_access: new Date(),
              first_name: firstName,
              email: normalizedEmail,
              last_name: lastName,
              phone_number: "",
              customer_id: res?.data.id,
              extra: "extra",
            };
            createCustomer(token, customerData, res?.data.id)
              .then(() => {
                sendSubscriptionEmail(normalizedEmail).catch(err => console.error("EmailJS error:", err));
                
                // Auto-login the user immediately upon registration
                const loginData = {
                  username: normalizedEmail,
                  password: item.password,
                  restaurant_id: RESTAURANT_ID,
                };
                userLogin(token, loginData)
                  .then((loginRes) => {
                    if (loginRes.status === 200) {
                      const userData = loginRes?.data;
                      localStorage.setItem("isGuest", "false");
                      dispatch(getUserTokenAction(loginRes?.data));
                      
                      if (userData) {
                        cartAvailability(token, userData.id).then((cartRes) => {
                          if (cartRes?.data.results?.length < 1) {
                            const newCartData = {
                              customer_id: userData.id,
                              restaurant: RESTAURANT_ID,
                            };
                            createCart(token, newCartData).then(() => {
                              cartAvailability(token, userData.id).then((availRes) => {
                                dispatch(userCartDetails(availRes?.data));
                                if (preLoginCount > 0) {
                                  const addToCartPromises = preLoginCart?.map((cartItem) => {
                                    let data = {
                                      price: cartItem.price,
                                      quantity: cartItem.quantity,
                                      cart_id: availRes?.data?.results?.[0]?.id,
                                      product_id: cartItem.product_id,
                                      color_id: cartItem.color_id,
                                    };
                                    return addToCart(token, data).then(async (r) => r?.data);
                                  });
                                  Promise.all(addToCartPromises).then(() => {
                                    dispatch(clearPreLoginCart());
                                    getCartItems(token, availRes?.data.results[0].id).then((fetchRes) => {
                                      dispatch(userCartItems(fetchRes?.data));
                                    });
                                  });
                                }
                              });
                            });
                          } else {
                            dispatch(userCartDetails(cartRes?.data));
                            if (preLoginCount > 0) {
                              const addToCartPromises = preLoginCart?.map((cartItem) => {
                                let data = {
                                  price: cartItem.price,
                                  quantity: cartItem.quantity,
                                  cart_id: cartRes?.data?.results?.[0]?.id,
                                  product_id: cartItem.product_id,
                                  color_id: cartItem.color_id,
                                };
                                return addToCart(token, data).then(async (r) => r?.data);
                              });
                              Promise.all(addToCartPromises).then(() => {
                                dispatch(clearPreLoginCart());
                                getCartItems(token, cartRes?.data.results[0].id).then((fetchRes) => {
                                  dispatch(userCartItems(fetchRes?.data));
                                });
                              });
                            } else {
                              getCartItems(token, cartRes?.data.results[0].id).then((fetchRes) => {
                                dispatch(userCartItems(fetchRes?.data));
                              });
                            }
                          }
                        });
                      }
                      
                      setLoading(false);
                      toast.success("Welcome! Please complete your profile details.");
                      if (onHide) onHide();
                      navigate("/my-account/profile");
                    } else {
                      setLoading(false);
                      setRegisteredEmail(normalizedEmail);
                      setView("registration_success");
                      sessionStorage.setItem('has_registered', 'true');
                    }
                  })
                  .catch(() => {
                    setLoading(false);
                    setRegisteredEmail(normalizedEmail);
                    setView("registration_success");
                    sessionStorage.setItem('has_registered', 'true');
                  });
              })
              .catch(() => {
                sendSubscriptionEmail(normalizedEmail).catch(err => console.error("EmailJS error:", err));
                // Fallback login flow even if customer creation failed so they can still access My Account
                const loginData = {
                  username: normalizedEmail,
                  password: item.password,
                  restaurant_id: RESTAURANT_ID,
                };
                userLogin(token, loginData)
                  .then((loginRes) => {
                    if (loginRes.status === 200) {
                      localStorage.setItem("isGuest", "false");
                      dispatch(getUserTokenAction(loginRes?.data));
                      setLoading(false);
                      toast.success("Welcome! Please complete your profile details.");
                      if (onHide) onHide();
                      navigate("/my-account/profile");
                    } else {
                      setLoading(false);
                      setRegisteredEmail(normalizedEmail);
                      setView("registration_success");
                      sessionStorage.setItem('has_registered', 'true');
                    }
                  })
                  .catch(() => {
                    setLoading(false);
                    setRegisteredEmail(normalizedEmail);
                    setView("registration_success");
                    sessionStorage.setItem('has_registered', 'true');
                  });
              });
          } else {
            setLoading(false);
            const errData = res?.data || {};
            const errStr = JSON.stringify(errData).toLowerCase();
            if (errStr.includes('exist')) {
              setErrorMsg('Password is incorrect.');
            } else if (errData.email && Array.isArray(errData.email)) {
              setErrorMsg(errData.email[0]);
            } else if (errData.username && Array.isArray(errData.username)) {
              setErrorMsg(errData.username[0]);
            } else if (errData.message) {
              setErrorMsg(errData.message);
            } else {
              setErrorMsg('Incorrect email or password. Please try again.');
            }
          }
        })
        .catch((regErr) => {
          setLoading(false);
          const errData = regErr?.response?.data || {};
          const errStr = JSON.stringify(errData).toLowerCase();
          if (errStr.includes('exist')) {
            setErrorMsg('Password is incorrect.');
          } else if (errData.email && Array.isArray(errData.email)) {
            setErrorMsg(errData.email[0]);
          } else if (errData.username && Array.isArray(errData.username)) {
            setErrorMsg(errData.username[0]);
          } else if (errData.message) {
            setErrorMsg(errData.message);
          } else {
            setErrorMsg('Incorrect email or password. Please try again.');
          }
        });
    });
  };

  const forgotUsername = (item) => {
    // console.log(item);
  };

  const guestLogin = (item) => {
    // Fallback to item.mobileNumber if state is null due to inputMobileNumber errors
    const finalNumber = mobileNumber || item.mobileNumber;
    
    // Ensure state is updated so otpVerification uses the exact same number
    setMobileNumber(finalNumber);

    const data = {
      phone_number: finalNumber,
      country_code: "+91", 
    };

    setLoading(true);
    userGuestLogin(token, data)
      .then((res) => {
        if (res && res.status === 200 && res.data?.status !== "error" && !res.data?.error) {
          // Artificial delay so the SMS has time to arrive while the user sees "Please wait..."
          setTimeout(() => {
            setLoading(false);
            setView("guest_otp");
            toast.success(res?.data?.message || "OTP Sent Successfully");
          }, 2000);
        } else {
          setLoading(false);
          toast.error(res?.data?.message || res?.data?.msg || res?.data?.error || "Failed to send OTP. (Backend Error)");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response?.data?.message || err.response?.data?.msg || "API Error: Guest Login endpoint not found on backend!");
      });
  };

  const handleResendOtp = () => {
    reset5();
    setErrorMsg("");
    // Re-trigger login with the existing mobileNumber
    guestLogin({ mobileNumber });
  };

  const otpVerification = (item) => {
    const data = {
      verification_code: item.otp1 + item.otp2 + item.otp3 + item.otp4,
      phone_number: mobileNumber,
    };

    setLoading(true);
    guestOtpVerification(token, data)
      .then((res) => {
        setLoading(false);
        if (res.status === 200 || res.status === 201) {
          const userData = res?.data;

          localStorage.setItem("isGuest", "true");
          dispatch(getUserTokenAction(userData));

          if (userData) {
            cartAvailability(token, userData.id).then((res) => {
              if (res?.data.results?.length < 1) {
                const cartData = {
                  customer_id: userData.id,
                  restaurant: RESTAURANT_ID,
                };

                createCart(token, cartData).then((createRes) => {
                  cartAvailability(token, userData.id).then((availRes) => {
                    dispatch(userCartDetails(availRes?.data));

                    if (preLoginCount > 0) {
                      const addToCartPromises = preLoginCart?.map((cartItem) => {
                        let addItemData = {
                          price: cartItem.price,
                          quantity: cartItem.quantity,
                          cart_id: availRes?.data?.results?.[0]?.id,
                          product_id: cartItem.product_id,
                          color_id: cartItem.color_id,
                        };

                        return addToCart(token, addItemData).then(async (addRes) => {
                          return addRes?.data;
                        });
                      });

                      Promise.all(addToCartPromises)
                        .then((results) => {
                          dispatch(clearPreLoginCart());
                          getCartItems(token, availRes?.data.results[0].id).then((fetchRes) => {
                            dispatch(userCartItems(fetchRes?.data));
                          });
                        })
                        .catch((error) => {
                          console.error("Error adding to cart:", error);
                        });
                    } else {
                      getCartItems(token, availRes?.data.results[0].id).then((fetchRes) => {
                        dispatch(userCartItems(fetchRes?.data));
                      });
                    }
                  }).catch((err) => console.warn(err));
                }).catch((err) => console.warn(err));
              } else {
                cartAvailability(token, userData.id).then((availRes) => {
                  dispatch(userCartDetails(availRes?.data));

                  if (preLoginCount > 0) {
                    const addToCartPromises = preLoginCart?.map((cartItem) => {
                      let addItemData = {
                        price: cartItem.price,
                        quantity: cartItem.quantity,
                        cart_id: availRes?.data?.results?.[0]?.id,
                        product_id: cartItem.product_id,
                        color_id: cartItem.color_id,
                      };

                      return addToCart(token, addItemData).then(async (addRes) => {
                        return addRes?.data;
                      });
                    });

                    Promise.all(addToCartPromises)
                      .then((results) => {
                        dispatch(clearPreLoginCart());
                        getCartItems(token, availRes?.data.results[0].id).then((fetchRes) => {
                          dispatch(userCartItems(fetchRes?.data));
                        });
                      })
                      .catch((error) => {
                        console.error("Error adding to cart:", error);
                      });
                  } else {
                    getCartItems(token, availRes?.data.results[0].id).then((fetchRes) => {
                      dispatch(userCartItems(fetchRes?.data));
                    });
                  }
                }).catch((err) => console.warn(err));
              }
            }).catch((err) => {
               console.warn("Cart availability error during guest login:", err?.message);
            });
          }

          reset();

          setTimeout(() => {
            if (preLoginCount > 0) {
              navigate("/checkout");
            } else {
              window.location.href = "/"; // Force a full page reload to home to ensure guest state is properly initialized globally
            }
          }, 1000);
        } else {
          setErrorMsg(res?.data?.message || res?.data?.error || "Incorrect OTP entered. Please try again.");
        }
      })
      .catch((err) => {
        setLoading(false);
        setErrorMsg(err.response?.data?.message || err.response?.data?.error || "OTP Verification Error.");
      });
  };

  const forgotPassword = (item) => {
    // console.log(item);
    setLoading(true);
    setErrorMsg("");
    const data = {
      username: item.email3 || item.email,
    };

    userForgotPassword(token, data).then((res) => {
      setLoading(false);
      if (res && res.status === 200) {
        setView("reset_success");
      } else if (res && res.status === 500 && res.data?.message?.includes("NoneType")) {
        setErrorMsg("The provided email is not registered! Please check and try again.");
      } else {
        setErrorMsg("The provided email is not registered! Please check and try again.");
      }
    })
    .catch((err) => {
      setLoading(false);
      setErrorMsg("Error sending reset link. Please try again.");
    });
  };

  const inputMobileNumber = () => {
    const mobileNumberPattern = /^[0-9]{10}$/;
    const mobileNumberValue = intlTelInputRef.current?.state?.value || "";
    const title = intlTelInputRef.current?.state?.title || "";
    const code = title ? title.split(" ")[2] : "";
    
    if (mobileNumberValue) {
      setValue4("mobileNumber", mobileNumberValue);
      clearErrors4("mobileNumber");
    } else {
      setValue4("mobileNumber", "");
    }

    if (mobileNumberPattern.test(mobileNumberValue)) {
      setMobileNumber(code + mobileNumberValue);
    } else {
      setMobileNumber(mobileNumberValue);
    }
  };

  if (show === false) return null;

  return (
    <>
      <div className="bam-modal-overlay">
      <ToastContainer
        position="top-center"
        className="mt-4 ToastContainer"
        limit={1}
        containerId="login"
      />
      <div className="bam-modal-card">
          <button className="bam-modal-close" onClick={() => onHide ? onHide() : navigate("/")} aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          {view === "login" && (
            <>
              {/* Logo */}
              <div className="bam-modal-header">
                <img src="/assets/img/bamboosa/bamboosa-logo.png" alt="Bamboosa" className="bam-modal-logo" />
              </div>

              {/* Divider Line */}
              <div className="bam-modal-divider"></div>

              {/* Headline */}
              <div className="bam-headline">
                <h3>Signup or Login</h3>
                <p className="bam-headline-sub">Join the Bamboosa Family to enjoy exclusive deals,<br/> &amp; early access to new collections.</p>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmitSignIn(signIn)} className="bam-form" noValidate>
                {errorMsg && (
                  <div className="bam-error-block">
                    {errorMsg}
                  </div>
                )}
                
                <div className="bam-input-wrap">
                  <span className="bam-input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#63a943" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                  </span>
                  <input
                    type="email"
                    className="bam-input"
                    placeholder="Email Address"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Invalid Email Address",
                      },
                    })}
                    maxLength={50}
                    required
                  />
                  {errors.email && <span className="bam-input-error" style={{ position: 'absolute', bottom: '-18px', left: '0', fontSize: '11px', color: '#d32f2f' }}>{errors.email.message}</span>}
                </div>

                <div className="bam-input-wrap" style={{ marginTop: '4px', position: 'relative' }}>
                  <span className="bam-input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#63a943" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="bam-input"
                    placeholder="Password"
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 8,
                        message: "Please use at least 8 characters for the password."
                      }
                    })}
                    maxLength={20}
                    required
                  />
                  <span 
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: 'pointer', position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}
                  >
                    {showPassword ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                  </span>
                  {errors.password && <span className="bam-input-error" style={{ position: 'absolute', bottom: '-18px', left: '0', fontSize: '11px', color: '#d32f2f' }}>{errors.password.message}</span>}
                </div>

                <div className="d-flex justify-content-between align-items-center" style={{ marginTop: "22px", marginBottom: "15px", fontSize: "14px", width: "100%" }}>
                  <div>
                    <span 
                      onClick={() => setView("guest_login")} 
                      style={{ color: "red", fontWeight: "600", cursor: "pointer", textDecoration: "underline" }}
                    >
                      Guest Sign In
                    </span>
                  </div>
                  <div>
                    <span style={{ color: "#555" }}>Forgot your password? </span>
                    <span
                      onClick={() => { setView("forgot_password"); setErrorMsg(""); }}
                      style={{ cursor: "pointer", color: "#dc3545", fontWeight: "600", textDecoration: "none" }}
                    >
                      Reset it
                    </span>
                  </div>
                </div>

                {errorMsg && (errorMsg.toLowerCase().includes('not verified') || errorMsg.toLowerCase().includes('verify your email')) && (
                  <div style={{ textAlign: "center", marginBottom: "15px", fontSize: "14px", padding: "10px", backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px" }}>
                    <span style={{ color: "#555", display: "block", marginBottom: "5px" }}>Didn't receive the verification email?</span>
                    <button
                      type="button"
                      onClick={() => {
                        const currentEmail = getValues("email");
                        if (currentEmail) {
                           setRegisteredEmail(currentEmail);
                           setErrorMsg("");
                           setView("registration_success");
                        } else {
                           toast.error("Please enter your email to resend the link.");
                        }
                      }}
                      style={{ 
                        background: "none", 
                        border: "none", 
                        cursor: "pointer", 
                        color: "#106c4b", 
                        fontWeight: "bold", 
                        textDecoration: "underline",
                        padding: 0
                      }}
                    >
                      Resend Verification Link
                    </button>
                  </div>
                )}

                <button type="submit" className="bam-submit-btn" disabled={loading || isSubmitting} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  {(loading || isSubmitting) ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '1rem', height: '1rem', borderWidth: '0.15em' }}></span>
                      Please wait...
                    </>
                  ) : (
                    "Join Bamboosa"
                  )}
                </button>
              </form>

              {/* Footer */}
              <div className="bam-modal-footer">
                <p>
                  By continuing, I accept the&nbsp;
                  <Link to="/privacy-policy" onClick={() => onHide && onHide()}>Privacy Policy</Link>&nbsp;and&nbsp;<Link to="/terms-and-conditions" onClick={() => onHide && onHide()}>T&amp;Cs</Link>.
                </p>
              </div>
            </>
          )}
          {view === "registration_success" && (
            <div className="bam-modal-content" style={{ textAlign: "center", padding: "40px 20px" }}>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ width: "60px", height: "60px", borderRadius: "50%", backgroundColor: "#19532d", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
              </div>
              <h3 style={{ color: "#19532d", marginBottom: "15px", fontSize: "24px", fontWeight: "700" }}>You're In! <span role="img" aria-label="party">🎉</span></h3>
              
              <p style={{ color: "#555", marginBottom: "20px", fontSize: "15px", lineHeight: "1.6" }}>
                A verification email has been sent to<br />
                <strong>{registeredEmail}</strong>.
              </p>
              
              <p style={{ color: "#555", marginBottom: "30px", fontSize: "14px", lineHeight: "1.6" }}>
                Please check your inbox — and your <span style={{ backgroundColor: "#fff3cd", color: "#856404", padding: "2px 6px", borderRadius: "4px", fontStyle: "italic", fontWeight: "500" }}>spam folder</span> if you don't see it!
              </p>
              
              <button 
                className="bam-submit-btn" 
                style={{ backgroundColor: "#19532d", color: "#fff", border: "none", marginBottom: "15px" }}
                onClick={() => {
                  navigate("/my-account/profile");
                  if (onHide) onHide();
                }}
              >
                Complete Profile
              </button>
              
              <div style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}>
                Didn't receive the email?{" "}
                {resendEmailStatus === "sent" ? (
                  <span style={{ color: "#19532d", fontWeight: "600" }}>Sent!</span>
                ) : resendEmailStatus === "loading" ? (
                  <span style={{ color: "#19532d" }}>Sending...</span>
                ) : (
                  <button 
                    onClick={() => {
                      setResendEmailStatus("loading");
                      sendSubscriptionEmail(registeredEmail)
                        .then(() => setResendEmailStatus("sent"))
                        .catch(() => {
                          toast.error("Failed to resend email. Please try again later.");
                          setResendEmailStatus("idle");
                        });
                    }}
                    style={{ 
                      background: "none", 
                      border: "none", 
                      color: "#19532d", 
                      textDecoration: "underline", 
                      fontWeight: "600", 
                      cursor: "pointer", 
                      padding: 0 
                    }}
                  >
                    Resend it now
                  </button>
                )}
              </div>
            </div>
          )}

          {view === "forgot_password" && (
            <div className="bam-modal-content">
              {/* Logo */}
              <div className="bam-modal-header">
                <img src="/assets/img/bamboosa/bamboosa-logo.png" alt="Bamboosa" className="bam-modal-logo" />
              </div>

              {/* Divider Line */}
              <div className="bam-modal-divider"></div>

              {/* Headline */}
              <div className="bam-headline">
                <h3>Reset Password</h3>
                <p className="bam-headline-sub">Enter your email to receive a reset link.</p>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmitForgotPassword(forgotPassword)} className="bam-form" noValidate>
                {errorMsg && (
                  <div className="bam-error-block">
                    {errorMsg}
                  </div>
                )}
                
                <div className="bam-input-wrap">
                  <span className="bam-input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#63a943" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                  </span>
                  <input
                    type="email"
                    className="bam-input"
                    placeholder="Email Address"
                    {...register3("email3", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Invalid Email Address",
                      },
                    })}
                    maxLength={50}
                    required
                  />
                  {errors3.email3 && <span className="bam-input-error" style={{ position: 'absolute', bottom: '-18px', left: '0', fontSize: '11px', color: '#d32f2f' }}>{errors3.email3.message}</span>}
                </div>

                <button type="submit" className="bam-submit-btn" style={{ marginTop: '25px' }} disabled={loading}>
                  {loading ? "Sending..." : "Reset Password"}
                </button>

                <div style={{ textAlign: "center", marginTop: "15px", fontSize: "14px" }}>
                  <span
                    onClick={() => { setView("login"); setErrorMsg(""); }}
                    style={{ cursor: "pointer", color: "#19532d", fontWeight: "600", textDecoration: "none" }}
                  >
                    ← Back to Login
                  </span>
                </div>
              </form>
            </div>
          )}

          {view === "reset_success" && (
            <div className="bam-success-state">
              <div className="bam-success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>
              </div>
              <h3>Check Your Email</h3>
              <p>
                We have sent a new password to your registered email address. 
                <br /><br />
                Please check your inbox and your <span className="bam-spam-note">spam folder</span>.
              </p>
              <button className="bam-submit-btn" onClick={() => setView("login")}>
                Back to Login
              </button>
            </div>
          )}

          {view === "guest_login" && (
            <>
              {/* Logo */}
              <div className="bam-modal-header">
                <img src="/assets/img/bamboosa/bamboosa-logo.png" alt="Bamboosa" className="bam-modal-logo" />
              </div>

              {/* Divider Line */}
              <div className="bam-modal-divider"></div>

              {/* Headline */}
              <div className="bam-headline">
                <h3 style={{color: "#008000"}}>Guest Sign In</h3>
                <p className="bam-headline-sub">Sign in as a Guest User!</p>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmitGuestLogin(guestLogin)} className="bam-form" noValidate>
                <div className="bam-input-wrap" style={{ border: 'none', background: 'transparent', padding: 0, overflow: 'visible' }}>
                  <IntlTelInput
                    {...register4("mobileNumber", {
                      required: "Please Enter Mobile Number",
                    })}
                    ref={intlTelInputRef}
                    containerClassName="intl-tel-input w-100"
                    inputClassName="form-control bam-input"
                    defaultCountry={countryCode.toLowerCase() || 'in'}
                    autoPlaceholder="polite"
                    customPlaceholder={(placeholder) => placeholder ? placeholder.replace(/^0+/, '') : ""}
                    onPhoneNumberChange={() => inputMobileNumber()}
                    separateDialCode={true}
                  />
                  {errors4.mobileNumber && <span className="bam-input-error" style={{ position: 'absolute', bottom: '-18px', left: '0', fontSize: '11px', color: '#d32f2f' }}>{errors4.mobileNumber.message}</span>}
                </div>

                <button type="submit" className="bam-submit-btn" style={{ marginTop: '25px' }} disabled={loading}>
                  {loading ? "Please wait..." : "Request OTP"}
                </button>

                <div style={{ textAlign: "center", marginTop: "15px", fontSize: "14px", display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div>
                    <span style={{ color: "#555" }}>Not a Member?  <span
                      onClick={() => { setView("login"); setErrorMsg(""); }}
                      style={{ cursor: "pointer", color: "#19532d", fontWeight: "600", textDecoration: "none" }}
                    >
                      Sign Up
                    </span></span>
                    {/* <Link to="/login" style={{ color: "#19532d", fontWeight: "600", textDecoration: "none" }}>Sign Up</Link> */}
                 
                  </div>
                  <div>
                    <span
                      onClick={() => { setView("login"); setErrorMsg(""); }}
                      style={{ cursor: "pointer", color: "#19532d", fontWeight: "600", textDecoration: "none" }}
                    >
                      ← Back to Login
                    </span>
                  </div>
                </div>
              </form>

              {/* Footer */}
              <div className="bam-modal-footer">
                <p>
                  By continuing, I accept the&nbsp;
                  <Link to="/privacy-policy" onClick={() => onHide && onHide()}>Privacy Policy</Link>&nbsp;and&nbsp;<Link to="/terms-and-conditions" onClick={() => onHide && onHide()}>T&amp;Cs</Link>.
                </p>
              </div>
            </>
          )}

          {view === "guest_otp" && (
            <div className="bam-modal-content">
              {/* Logo */}
              <div className="bam-modal-header">
                <img src="/assets/img/bamboosa/bamboosa-logo.png" alt="Bamboosa" className="bam-modal-logo" />
              </div>

              {/* Divider Line */}
              <div className="bam-modal-divider"></div>

              {/* Headline */}
              <div className="bam-headline">
                <h3 style={{color: "#008000"}}>OTP Verification</h3>
                <p className="bam-headline-sub">Enter OTP sent to your Mobile!</p>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmitOTPVerification(otpVerification)} className="bam-form" noValidate>
                {errorMsg && (
                  <div className="bam-error-block">
                    {errorMsg}
                  </div>
                )}
                
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', margin: '25px 0' }}>
                  {[1, 2, 3, 4].map((num) => {
                    const { onChange, onBlur, name, ref } = register5(`otp${num}`, { required: true });
                    return (
                      <input
                        key={num}
                        type="text"
                        maxLength="1"
                        name={name}
                        ref={ref}
                        onBlur={onBlur}
                        className="bam-input text-center"
                        style={{ width: '50px', padding: '10px', fontSize: '18px', border: '1px solid #ccc' }}
                        onChange={(e) => {
                          onChange(e);
                          if (e.target.value.length >= 1) {
                            const next = e.target.nextElementSibling;
                            if (next && next.tagName === 'INPUT') {
                              next.focus();
                            } else {
                              if (e.target.form) e.target.form.requestSubmit();
                            }
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" && e.target.value === "") {
                            const prev = e.target.previousElementSibling;
                            if (prev && prev.tagName === 'INPUT') {
                              prev.focus();
                            }
                          }
                        }}
                      />
                    );
                  })}
                </div>
                {Object.keys(errors5).length > 0 && (
                  <span className="bam-input-error" style={{ display: 'block', textAlign: 'center', fontSize: '12px', color: '#d32f2f', marginBottom: '15px' }}>
                    Please enter complete OTP
                  </span>
                )}

                <button type="submit" className="bam-submit-btn" style={{ marginTop: '15px' }} disabled={loading}>
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>

                <div style={{ textAlign: "center", marginTop: "15px", fontSize: "14px", display: "flex", flexDirection: "column", gap: "15px" }}>
                  <div>
                    <span style={{ color: "#555" }}>Didn't receive the code? </span>
                    <span
                      onClick={handleResendOtp}
                      style={{ cursor: "pointer", color: "#19532d", fontWeight: "600", textDecoration: "none" }}
                    >
                      Resend OTP
                    </span>
                  </div>
                  <div>
                    <span
                      onClick={() => { setView("guest_login"); }}
                      style={{ cursor: "pointer", color: "#19532d", fontWeight: "600", textDecoration: "none" }}
                    >
                      ← Back to Mobile Number
                    </span>
                  </div>
                </div>
              </form>
            </div>
          )}
      </div>
      </div>
    </>
  );
}
